<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
export default {
  name: 'ipasas',
  mixins: [userRole],
  computed: {
    ...mapGetters(['userSutikimas', 'ipasasNative']),
    iPasasRedirectUrl() {
      return process.env.VUE_APP_IPASAS_REDIRECT_URL ?? null
    },
  },
  created() {
    this.ipasasAuth()
  },
  methods: {
    ipasasAuth() {
      if (this.$route.query.enc) {
        if (
          (process.env.VUE_APP_LOCAL === 'test' ||
            process.env.VUE_APP_LOCAL === 'preprod') &&
          !this.ipasasNative &&
          this.iPasasRedirectUrl
        ) {
          window.location.href = `${this.iPasasRedirectUrl}?enc=${this.$route.query.enc}&lang=lt`
          return
        }

        this.loading = true
        this.$store
          .dispatch('ipasasLogin', { enc: this.$route.query.enc })
          .then(() => {
            this.$store.dispatch('loadTooltips')
            this.$store.dispatch('searchParams', null)
            this.$store.dispatch('ipasasNative', 0)
            this.loading = false

            this.$router.push({ name: this.userHomeRoute() })
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        this.$store.dispatch('keepAlive', false)
        this.$router.push({ name: 'login' })
      }
    },
    userHomeRoute() {
      if (!this.userSutikimas) {
        return 'sutikimas'
      }
      const gautasPranesimas = sessionStorage.getItem('gautasPranesimas')
      if (gautasPranesimas && gautasPranesimas.length > 0) {
        if (this.role(['KAC_darbuotojas'])) {
          return 'paieskaTvirtinimas'
        }
        if (this.roleRGV) {
          return 'zurnalasSiunciami'
        }
        return 'pagrindinis'
      }

      if (this.roleRGV) {
        return 'zurnalasGaunami'
      }
      if (this.role(['KAC_darbuotojas'])) {
        return 'paieskaTvirtinimas'
      }
      if (this.roleSkaitytojas) {
        return 'zurnalasGaunami'
      }
      if (!this.roleDT && !this.roleRGV && this.rolePaieska) {
        return 'paieskaTab'
      }
      if (this.role(['AD_administratorius'])) {
        return 'administravimas'
      }
      return 'home'
    },
  },
}
</script>
